import { render, staticRenderFns } from "./import.vue?vue&type=template&id=31981da1&"
import script from "./import.vue?vue&type=script&lang=ts&"
export * from "./import.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports